import { render, staticRenderFns } from "./edit-question-modal.vue?vue&type=template&id=60ca1955&"
import script from "./edit-question-modal.vue?vue&type=script&lang=js&"
export * from "./edit-question-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports